import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
import { isPresent } from '@ember/utils';
export const FNBKioskDiningOption = ProtoBaseModel.extend({
  diningOptionId: attr(String),
  kioskOrdinal: attr(Number)
});
export default ProtoBaseModel.extend({
  allowGiftCards: attr(Boolean),
  diningOptions: repeated(FNBKioskDiningOption),
  showSoldOutItems: attr(Boolean),
  giftCardDisplayValueTranslationKey: computed('allowGiftCards', function () {
    return this.allowGiftCards ? 'business.devices.profiles.v2.settings.checkout.kioskPayment.allowGiftCards.enabled' : '';
  }),
  diningOptionIds: computed('diningOptions', function () {
    const filteredDiningOptions = this.diningOptions.filter(diningOption =>
    // server returns an empty object on default profile creation
    isPresent(diningOption.diningOptionId));
    return filteredDiningOptions.map(fnbKioskDiningOption => fnbKioskDiningOption.diningOptionId);
  }),
  soldOutItemsDisplayValueTranslationKey: computed('showSoldOutItems', function () {
    return this.showSoldOutItems ? 'business.devices.profiles.v2.settings.checkout.showSoldOutItems.on' : 'business.devices.profiles.v2.settings.checkout.showSoldOutItems.off';
  })
});